var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u5907\u4EFD 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "58.7200081%",
    x2: "0%",
    y2: "58.7200081%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.698153409,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20220317\\u7ECF\\u8425\\u60C5\\u51B5\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-46",
    transform: "translate(-663.000000, -228.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(646.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31",
    transform: "translate(0.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-29",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14285714,4.23076923 L6.28571429,4.23076923 L6.28571429,7.46153846 L3.14285714,7.46153846 L3.14285714,4.23076923 Z M3.14285714,15.5384615 L6.28571429,15.5384615 L6.28571429,18.7692308 L3.14285714,18.7692308 L3.14285714,15.5384615 Z M3.14285714,9.88461538 L6.28571429,9.88461538 L6.28571429,13.1153846 L3.14285714,13.1153846 L3.14285714,9.88461538 Z M1.57142857,2.61538462 L3.14285714,2.61538462 L3.14285714,1 L0,1 L0,22 L3.14285714,22 L3.14285714,20.3846154 L1.57142857,20.3846154 L1.57142857,2.61538462 Z M15.7142857,4.23076923 L18.8571429,4.23076923 L18.8571429,7.46153846 L15.7142857,7.46153846 L15.7142857,4.23076923 Z M15.7142857,9.88461538 L18.8571429,9.88461538 L18.8571429,13.1153846 L15.7142857,13.1153846 L15.7142857,9.88461538 Z M18.8571429,2.61538462 L20.4285714,2.61538462 L20.4285714,20.3846154 L18.8571429,20.3846154 L18.8571429,22 L22,22 L22,1 L18.8571429,1 L18.8571429,2.61538462 Z M9.42857143,4.23076923 L12.5714286,4.23076923 L12.5714286,7.46153846 L9.42857143,7.46153846 L9.42857143,4.23076923 Z M15.7142857,15.5384615 L18.8571429,15.5384615 L18.8571429,18.7692308 L15.7142857,18.7692308 L15.7142857,15.5384615 Z M9.42857143,9.88461538 L12.5714286,9.88461538 L12.5714286,13.1153846 L9.42857143,13.1153846 L9.42857143,9.88461538 Z M9.42857143,15.5384615 L12.5714286,15.5384615 L12.5714286,18.7692308 L9.42857143,18.7692308 L9.42857143,15.5384615 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.8ac713bec702866a3fd351b67ff8928b.svg";
export { ForwardRef as ReactComponent };